export default __webpack_public_path__ + "static/media/passport.8cf8e29e.png";